import React from "react";
import { NewsEventModel } from "../../../domain/entities/NewsEventModel";
import AnotherNewsEventItemComponents from "./AnotherNewsEventItemComponents";

interface AnotherNewsEventListProps {
    newsList: NewsEventModel[]
}

const AnotherNewsEventListComponents: React.FC<AnotherNewsEventListProps> = ({newsList}) => {
    return (
        // Main container
        <div className="w-full mx-auto px-2 md:px-4 lg:px-6 py-4 md:py-6">
            {/* Heading */}
            <h4 className="text-base md:text-lg font-bold text-start mb-2 font-poppins">
                Berita dan Acara Lainnya
            </h4>
    
            {/* Scroll container with position relative for overlay positioning */}
            <div className="relative">
                {/* Scrollable area with no padding to prevent cropping */}
                <div className="overflow-x-auto md:scroll-smooth">
                    {/* Content wrapper with padding to create space from edges */}
                    <div className="flex flex-col gap-2 md:gap-4 h-auto">
                        {newsList.map((item) => (
                            <div 
                                key={item.id} 
                                className="w-full md:w-80 flex-shrink-0"
                            >
                                <AnotherNewsEventItemComponents 
                                    newsEvent={item} 
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AnotherNewsEventListComponents;